import React from 'react';
import { useMsal } from '@azure/msal-react';
import styled from 'styled-components';

const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutPopup().catch(e => {
      console.error('Logout failed:', e);
    });
  };

  return (
    <StyledButton onClick={handleLogout}>
      Sign Out
    </StyledButton>
  );
};

const StyledButton = styled.button`
  background: #d13438;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #b02a2e;
  }

  &:active {
    background: #8f2124;
  }
`;

export default SignOutButton;
